/* eslint-disable @typescript-eslint/no-explicit-any */
import IconAggregate from '@assets/icons/aggregate.svg?react';
import IconBigArrowBottom from '@assets/icons/big arrow bottom.svg?react';
import IconBigArrowTop from '@assets/icons/big arrow top.svg?react';
import IconGroup from '@assets/icons/group.svg?react';
import { useTheme } from '@mui/material';
import { GridPremiumSlotsComponent } from '@mui/x-data-grid-premium';

import HeaderFilterIcon from './HeaderFilterIcon';

const gridSlotsIcons = {
 columnHeaderFilterIconButton: HeaderFilterIcon,
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuGroupIcon: () => {
  const th = useTheme();
  return <IconGroup style={{ color: th.palette.kemek.darkestGray }} />;
 },
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuUngroupIcon: () => {
  const th = useTheme();
  return <IconGroup style={{ color: th.palette.kemek.darkestGray }} />;
 },
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuSortAscendingIcon: () => {
  const th = useTheme();
  return <IconBigArrowTop style={{ color: th.palette.kemek.darkestGray }} />;
 },
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuSortDescendingIcon: () => {
  const th = useTheme();
  return <IconBigArrowBottom style={{ color: th.palette.kemek.darkestGray }} />;
 },
 // eslint-disable-next-line react/no-unstable-nested-components
 columnMenuAggregationIcon: () => {
  const th = useTheme();
  return <IconAggregate style={{ color: th.palette.kemek.darkestGray }} />;
 },
} as Partial<GridPremiumSlotsComponent>;

export default gridSlotsIcons;

